import { FormProvider } from "react-hook-form";
import { Color, MagnifyingGlassIcon, TextFieldController } from "@bonliva-crm/ui";
import { Box, Divider, Typography, makeStyles, Fab } from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import { useAccommodationRequestSearchFilters } from "./hooks/use-accommodation-request-search-filters";
import { SearchProfileType } from "@bonliva-crm/graphql";
import { FilterSlider } from "@bonliva-crm/ui/search-filters";
import { FavouriteFilter } from "@bonliva-crm/ui/search-filters";
import { AccommodationRequestTable } from "./components/accommodation-request-table/accommodation-request-table";
import { AccommodationRequestCreateLocation } from "@bookings/BookingHospitality/locations/AccommodationRequestCreateLocation";
import React, { useCallback } from "react";
import { AccommodationRequest } from "@bookings/BookingHospitality/AccommodationRequest/AccommodationRequest";
import { useGlobalStore } from "@hooks";
import { Hotel } from "@material-ui/icons";
import { WithTooltip } from "@common";

export const AccommodationRequestSearchLayout = () => {
  const classes = useStyles();

  const { filterManager } = useAccommodationRequestSearchFilters();
  const { navigation } = useGlobalStore();

  const handleCreateAccommodationRequest = useCallback(() => {
    const request = AccommodationRequest.CreateNew("", "");

    navigation.open(
      "accommodation_request",
      new AccommodationRequestCreateLocation({
        bookingId: null,
        formProps: {
          bookingGroupId: null,
          isDisabled: false,
          initialValues: request,
          isNew: true
        }
      })
    );
  }, []);

  return (
    <FormProvider {...filterManager.formMethods}>
      <Box className={classes.root}>
        <Box className={classes.flexColumn}>
          <Box className={classes.flexRow} style={{ justifyContent: "space-between" }}>
            <Typography variant="h2">{locale.mainMenu.accommodationRequests}</Typography>
            <TextFieldController
              name="text"
              textFieldProps={{
                className: classes.searchField,
                placeholder: locale.Search,
                inputProps: { autoComplete: "off" },
                InputProps: {
                  startAdornment: <MagnifyingGlassIcon />,
                  style: { borderColor: Color.DarkGray }
                }
              }}
            />
            <WithTooltip title={locale.newAccommodationRequest}>
              <Fab
                color="primary"
                onClick={handleCreateAccommodationRequest}
                size="small"
              >
                <Hotel />
              </Fab>
            </WithTooltip>
          </Box>
          <FavouriteFilter
            filterManager={filterManager}
            searchProfileType={SearchProfileType.AccommodationRequests}
          />
          <Divider />
          <AccommodationRequestTable />
        </Box>
        <FilterSlider
          sortByLabel
          filterManager={filterManager}
          searchProfileType={SearchProfileType.AccommodationRequests}
        />
      </Box>
    </FormProvider>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2, 4, 5.2, 2),
    height: "100%"
  },
  flexColumn: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    height: "100%"
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(2)
  },
  searchField: {
    width: "60%"
  },
  allFilters: {
    padding: "0 1rem",
    border: `1px solid ${Color.LightGray}`,
    height: "2.5rem",
    borderRadius: "0.375rem",
    width: "125px",
    "&:hover": {
      cursor: "pointer"
    }
  }
}));
